import { render, staticRenderFns } from "./UnderReviewDialog.vue?vue&type=template&id=dcb0bb36&scoped=true&"
import script from "./UnderReviewDialog.vue?vue&type=script&lang=js&"
export * from "./UnderReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./UnderReviewDialog.vue?vue&type=style&index=0&id=dcb0bb36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb0bb36",
  null
  
)

export default component.exports